import { render, staticRenderFns } from "./searchForPrice.vue?vue&type=template&id=0b6980ca"
import script from "./searchForPrice.vue?vue&type=script&lang=js"
export * from "./searchForPrice.vue?vue&type=script&lang=js"
import style0 from "./searchForPrice.vue?vue&type=style&index=0&id=0b6980ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports